module.exports = __webpack_public_path__ + "static/media/g3p.fce24dd6.jpg";